import { Typography, FormInstance } from 'antd';
import { FC, useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { PrimaryMarketFiltersForm } from './PrimaryMarketFiltersForm';
import { PrimaryMarketSavedFilters } from './PrimaryMarketSavedFilters';
import { FiltersForm } from 'componets/ui/Filter/FiltersForm';
import { Filter } from 'componets/ui';
import { Filters } from 'componets/ui/Filter/Filters';

import { getFilters } from 'features/primaryMarket/actions';

import { FieldData, IFilter, IFilterValues, ISavedFilter } from 'models';

import Utils from 'utils/utils';

import { selectGlobals } from 'selectors';

import styles from './index.module.scss';
import { PrimaryMarketCalculator } from '../PrimaryMarketCalculator';
interface PrimaryMarketFilterProps {
	form: FormInstance;
	setFields: (changedFields: FieldData[], allFields?: FieldData[]) => void;
	fields: FieldData[];
	values: IFilterValues;
	initialValues: IFilterValues;
}
export const PrimaryMarketFilter: FC<PrimaryMarketFilterProps> = ({
	form,
	setFields,
	fields,
	values,
	initialValues,
}) => {
	const pager = useAppSelector((state) => state.primaryMarket.pager);
	const globals = useAppSelector(selectGlobals);

	const dispatch = useAppDispatch();

	const [activeFilter, setActiveFilter] = useState({} as ISavedFilter);
	const [isOpen, setIsOpen] = useState(false);
	const [filters, setFilters] = useState([] as IFilter[]);

	const { availableProjectsText} = useTranslate([
		'availableProjectsText',
	]);

	useEffect(() => {
		dispatch(getFilters());
	}, [dispatch]);

	useEffect(() => {
		let data: IFilter[] = [];

		if (values) {
			data = Utils.transformFilters(values, globals.countries);
		}

		setFilters(data);
	}, [globals.countries, values]);

	const onResetFields = () => {
		setActiveFilter({} as ISavedFilter);
		form.setFieldsValue({
			country: [],
			excludeMyInvestment: '',
			'interestRate[from]': undefined,
			'interestRate[to]': undefined,
			'ltv[from]': undefined,
			'ltv[to]': undefined,
			'riskLvl': '',
			type: [],
		});
	};

	const onClose = () => setIsOpen(false);

	return (
		<div>
			<div className={styles.root}>
				<div className={styles.row}>
					{!!pager.currentPage && (
						<Typography.Text type="secondary" className={styles.text}>
							{pager.totalCount > 0 && `${availableProjectsText}: ${pager.totalCount}`}
						</Typography.Text>
					)}

					<div className={styles.buttons}>
						<PrimaryMarketCalculator />

						<PrimaryMarketSavedFilters
							onSetFields={setFields}
							activeFilter={activeFilter}
							setActiveFilter={setActiveFilter}
						/>

						<Filter
							onResetFields={onResetFields}
							isOpen={isOpen}
							onOpen={() => setIsOpen(true)}
							onClose={onClose}
						>
							<PrimaryMarketSavedFilters
								onSetFields={setFields}
								activeFilter={activeFilter}
								setActiveFilter={setActiveFilter}
								onClose={onClose}
							/>
							<FiltersForm
								isPrimary
								onFinish={onClose}
								fields={fields}
								form={form}
								initialValues={initialValues}
								setFields={setFields}
								setActiveFilter={setActiveFilter}
								values={values}
								filters={filters}
							>
								<PrimaryMarketFiltersForm setFields={setFields} values={values} />
							</FiltersForm>
						</Filter>
					</div>
				</div>
			</div>
			<br/>
			{filters.length > 0 && (
				<Filters
					filters={filters}
					onReset={onResetFields}
					form={form}
					values={values}
					setActiveFiler={setActiveFilter}
				/>
			)}
		</div>
	);
};
